// extracted by mini-css-extract-plugin
export default {"sticky":"TableRowItem_sticky__i9Bpz","withBorder":"TableRowItem_withBorder__sy32O"};